import {
	listCreators,
	getCreator,
	updateCreator,
	toggleCreatorActive,
} from '@/services/academy/creators.service'
import {
	getCreatorServiceOfferings,
	getCreatorFinancial,
} from '@/services/academy/serviceOfferings.service'

export default {
	namespaced: true,
	state: {
		list: { data: [], meta: { total: 0 } },
		item: null,
		serviceOfferings: [],
		financial: null,
		listStatus: 'init',
		actionStatus: 'init',
		offeringsStatus: 'init',
		financialStatus: 'init',
	},
	getters: {
		getList:             (s) => s.list,
		getItem:             (s) => s.item,
		getServiceOfferings: (s) => s.serviceOfferings,
		getFinancial:        (s) => s.financial,
		getListStatus:       (s) => s.listStatus,
		getActionStatus:     (s) => s.actionStatus,
		getOfferingsStatus:  (s) => s.offeringsStatus,
		getFinancialStatus:  (s) => s.financialStatus,
	},
	mutations: {
		SET_LIST(state, v)              { state.list = v },
		SET_ITEM(state, v)              { state.item = v },
		SET_SERVICE_OFFERINGS(state, v) { state.serviceOfferings = v },
		SET_FINANCIAL(state, v)         { state.financial = v },
		SET_LIST_STATUS(state, v)       { state.listStatus = v },
		SET_ACTION_STATUS(state, v)     { state.actionStatus = v },
		SET_OFFERINGS_STATUS(state, v)  { state.offeringsStatus = v },
		SET_FINANCIAL_STATUS(state, v)  { state.financialStatus = v },
	},
	actions: {
		async fetchList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await listCreators(params)
				commit('SET_LIST', data)
				commit('SET_LIST_STATUS', 'init')
			} catch {
				commit('SET_LIST_STATUS', 'error')
			}
		},
		async fetchItem({ commit }, id) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await getCreator(id)
				commit('SET_ITEM', data.data ?? data)
				commit('SET_LIST_STATUS', 'init')
			} catch {
				commit('SET_LIST_STATUS', 'error')
			}
		},
		async fetchServiceOfferings({ commit }, id) {
			commit('SET_OFFERINGS_STATUS', 'pending')
			try {
				const { data } = await getCreatorServiceOfferings(id)
				commit('SET_SERVICE_OFFERINGS', data.data ?? [])
				commit('SET_OFFERINGS_STATUS', 'init')
			} catch {
				commit('SET_OFFERINGS_STATUS', 'error')
			}
		},
		async fetchFinancial({ commit }, id) {
			commit('SET_FINANCIAL_STATUS', 'pending')
			try {
				const { data } = await getCreatorFinancial(id)
				commit('SET_FINANCIAL', data.data ?? data)
				commit('SET_FINANCIAL_STATUS', 'init')
			} catch {
				commit('SET_FINANCIAL_STATUS', 'error')
			}
		},
		async update({ commit }, payload) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				await updateCreator(payload)
				commit('SET_ACTION_STATUS', 'success')
			} catch (e) {
				commit('SET_ACTION_STATUS', 'error')
				throw e
			}
		},
		async toggleActive({ commit }, id) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				const { data } = await toggleCreatorActive(id)
				commit('SET_ACTION_STATUS', 'success')
				return data
			} catch (e) {
				commit('SET_ACTION_STATUS', 'error')
				throw e
			}
		},
	},
}
